import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { api, sca } from 'services/api';

export default function AxiosAuthBridge() {
  const token = useSelector(state => state.userState?.user?.token);

  useEffect(() => {
    if (token) {
      api.defaults.headers.Authorization = `Bearer ${token}`;
      sca.defaults.headers.Authorization = `Bearer ${token}`;
    } else {
      delete api.defaults.headers.Authorization;
      delete sca.defaults.headers.Authorization;
    }
  }, [token]);

  return null;
}